import React from 'react';

import { Divider } from '../../Divider';

import styles from './Select.Divider.module.scss';

export const SelectDivider: React.SFC = () => (
  <div aria-hidden={true} className={styles.divider}>
    <Divider.Horizontal />
  </div>
);

SelectDivider.displayName = 'Select.Divider';
